/**
 * P6-19 · Shared (client-safe, no directive) so both the server announcement bar
 * — which emits the pre-paint hide script — and the client wrapper use the same
 * per-announcement sessionStorage key.
 */
export const announcementDismissKey = (id: string) =>
  `vx-announcement-dismissed:${id}`;
